import { Exchange, ExchangeInput, OperationResult } from "@urql/core";
import { pipe, tap } from "wonka";
import { operationCompleted, GraphqlActions } from "store";
import { Dispatch } from "redux";

type Options = {
  dispatch: Dispatch<GraphqlActions>;
};
/**
 * Pipe the operation history to redux, which allows us to log the operations to DataDog, in the event of a crash.
 * See AppErrorBoundary.tsx
 * @param dispatch
 */
export const cacheLoggerExchange: (opts: Options) => Exchange = ({
  dispatch
}) => ({ forward }: ExchangeInput) => {
  const logEnd = ({ data, ...res }: OperationResult) => {
    dispatch(operationCompleted(res));
  };
  return ops$ => pipe(ops$, forward, tap(logEnd));
};
